import Vue from 'vue';

export default {

      async fetchContactNumbers({ commit }) {
        return Vue.axios.get(Vue.$url("contact-number"))
          .then((rsp) => commit("SET_CONTACTNUMBER", rsp.data))
          
      },

      async fetchContactNumbersByDprId({ commit }, dprId) {
        return Vue.axios.get(Vue.$url("contact-number/"+ dprId + "/available"))
          .then((rsp) => commit("SET_CONTACTNUMBER", rsp.data))
          
      },

}